import About_Multiple_Banner from "./about_multiple_banner/About_Multiple_Banner";
import AboutBanner from "./AboutBanner/AboutBanner";
import AboutHiclousia from "./AboutHiclousia/AboutHiclousia";
import AboutText from "./AboutText/AboutText";
import Help from "./Help/Help"
import OurPartner from "./OurPartner/OurPartner";

function AboutUs() {
  return (
    <>
      <AboutBanner/>
      <AboutText/>
      <AboutHiclousia/>
      <About_Multiple_Banner/>
      <OurPartner/>
      <Help/>
    </>   
  );
}
export default AboutUs;